import { DisplacementModifier } from './DisplacementModifier';
import { TwistModifier } from './TwistModifier';
import { RadialWaveModifier } from './RadialWaveModifier';
import { RadialWrinkleModifier } from './RadialWrinkleModifier';
import { FacetModifier } from './FacetModifier';
import { LayerModifier } from './LayerModifier';
export class ModifierFactory {
    static fromJSON(data, noise3D) {
        const type = data.type.toLowerCase();
        const is_symmetrical = data.is_symmetrical !== undefined ? data.is_symmetrical : false;
        switch (type) {
            case 'displacement':
                return new DisplacementModifier(data.disabled, data.parameters, noise3D);
            case 'twist':
                return new TwistModifier(data.disabled, data.parameters);
            case 'radial_wave':
                return new RadialWaveModifier(data.disabled, data.parameters);
            case 'radial_wrinkle':
                return new RadialWrinkleModifier(data.disabled, data.parameters, noise3D);
            case 'facet':
                return new FacetModifier(data.disabled, data.parameters);
            case 'layer':
                return new LayerModifier(data.disabled, data.parameters, noise3D);
            default:
                throw new Error(`Unknown modifier type: ${data.type}`);
        }
    }
}
